export const MaritalStatusArray = [
  'Soltero/a',
  'Casado/a',
  'Divorciado/a',
  'Viudo/a',
  'Separado/a',
  'Conviviente civil',
  'Conviviente'
];
